export function getDaysUntilExpiration(expirationInput: string): number | null {
  const parsed = new Date(expirationInput + 'T00:00:00Z')
  if (isNaN(parsed.getTime())) {
    return null
  }

  const expirationDateUTC = Date.UTC(
    parsed.getUTCFullYear(),
    parsed.getUTCMonth(),
    parsed.getUTCDate()
  )
  const now = new Date()
  const currentDateUTC = Date.UTC(now.getUTCFullYear(), now.getUTCMonth(), now.getUTCDate())

  const msPerDay = 1000 * 60 * 60 * 24
  return Math.floor((expirationDateUTC - currentDateUTC) / msPerDay)
}
